"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const styles_1 = require("@material-ui/core/styles");
const styles_2 = require("@material-ui/styles");
const CreditoExpressProvider_1 = require("../CreditoExpressProvider");
const queryParams_1 = __importDefault(require("./queryParams"));
const temaPadrao_1 = __importDefault(require("./temaPadrao"));
const getTemaMaterialDefault = (temaOrganizacaoJson, propsTemaMaterialUi) => {
    if (propsTemaMaterialUi) {
        return propsTemaMaterialUi;
    }
    if (temaOrganizacaoJson) {
        return styles_1.createMuiTheme({ palette: JSON.parse(temaOrganizacaoJson) });
    }
    return temaPadrao_1.default;
};
const CeMuiThemeProvider = ({ children, useFetch, temaMaterialUi, }) => {
    const { state: { organizacao }, } = CreditoExpressProvider_1.useCreditoExpress();
    const { tema: temaOrganizacaoJson } = organizacao;
    const [temaMaterialDinamico, setTemaMaterialDinamico] = react_1.useState(getTemaMaterialDefault(temaOrganizacaoJson, temaMaterialUi));
    const [codigoOrganizacaoPorUrl, setCodigoOrganizacaoPorUrl] = react_1.useState('');
    const { retorno: retornoTemaPorUrl, send: sendBuscarTemaPorUrl, loading: loadingTemaPorUrl, } = useFetch({
        method: 'GET',
        url: `/api/organizacao/tema/${codigoOrganizacaoPorUrl}`,
    });
    const carregarCodigoOrganizacaoPorUrl = () => {
        const codigoUrl = queryParams_1.default();
        if (codigoUrl) {
            setCodigoOrganizacaoPorUrl(codigoUrl);
        }
    };
    react_1.useEffect(() => {
        if (!temaOrganizacaoJson && !temaMaterialUi) {
            carregarCodigoOrganizacaoPorUrl();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    react_1.useEffect(() => {
        if (organizacao && Object.keys(organizacao).length) {
            const { tema: temaJson } = organizacao;
            const temaMaterialObj = getTemaMaterialDefault(temaJson);
            setTemaMaterialDinamico(temaMaterialObj);
        }
    }, [organizacao]);
    react_1.useEffect(() => {
        if (temaMaterialUi) {
            setTemaMaterialDinamico(temaMaterialUi);
        }
    }, [temaMaterialUi]);
    react_1.useEffect(() => {
        if (codigoOrganizacaoPorUrl) {
            sendBuscarTemaPorUrl(codigoOrganizacaoPorUrl);
        }
    }, [codigoOrganizacaoPorUrl]); // eslint-disable-line react-hooks/exhaustive-deps
    react_1.useEffect(() => {
        if (retornoTemaPorUrl) {
            const { tema: temaOrganizacao } = retornoTemaPorUrl;
            const temaMaterial = { palette: JSON.parse(temaOrganizacao) };
            setTemaMaterialDinamico(styles_1.createMuiTheme(temaMaterial));
        }
    }, [retornoTemaPorUrl]);
    if (loadingTemaPorUrl) {
        return react_1.default.createElement(CircularProgress_1.default, { disableShrink: true, style: { color: '#969696' } });
    }
    return (react_1.default.createElement(styles_2.StylesProvider, { injectFirst: true },
        react_1.default.createElement(styles_1.MuiThemeProvider, { theme: temaMaterialDinamico },
            react_1.default.createElement(styled_components_1.ThemeProvider, { theme: temaMaterialDinamico }, children))));
};
exports.default = CeMuiThemeProvider;
//# sourceMappingURL=index.js.map